import { render, staticRenderFns } from "./Absolvation.vue?vue&type=template&id=98de2cea&scoped=true"
import script from "./Absolvation.vue?vue&type=script&lang=ts"
export * from "./Absolvation.vue?vue&type=script&lang=ts"
import style0 from "./Absolvation.vue?vue&type=style&index=0&id=98de2cea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98de2cea",
  null
  
)

export default component.exports